//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// WinePairingPage - Wine Recommendation based on Dinner Selection and Preferences
// Modern responsive layout: flexbox header/body (no fixed/absolute math), card-based
// meal & wine lists, clamp() fluid type sizing, and a true full-screen recommendation modal.
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import React from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from './withRouter';
import { SessionInfo } from './App';
import { Button } from '@progress/kendo-react-buttons';
import { Popup } from '@progress/kendo-react-popup';
import { TreeView } from '@progress/kendo-react-treeview';
import { TextArea } from '@progress/kendo-react-inputs';
import { CallOM,CallOMT,displayError,displayMessage,CTYP,TYP,trace } from './CommonCode.js';
import loadingGif from './images/loading.gif';

import { ReactComponent as MenuBar } from "./images/bars.svg";

class WinePairingPage extends React.Component {
  constructor(props) {
    super(props);
    if (!SessionInfo.session || SessionInfo.session === '')
      return;
  }
  menuAnchor = React.createRef();
  logoAnchor = React.createRef();
  mealListRef = React.createRef();
  state = {
    StoreItems: [],
    WinePreferenceComments: '',
    Recommendation: '',
    RecommendedWines: [],
    showMenu: false,
    showRecommendationPopup: false,
    NotifyMessage: '',
    NotifyIsError: false,
    isLoading: false,
    showGIF: false,
    showMealScrollHint: false,
  };

  recommendPos = React.createRef();
  monitorStart = false;
  firstTime = false;
  timerSet = false;
  lastExec = undefined;
  SetLinksTimer = 0;
  compUpdate = true;
  queryTimer = 0;
  detailOffset = { left: 5,top: 10 };
  recommendTime = 'Recommending wine based on your meal selection and preferences. This may take a few seconds ...';
  //
  async componentDidMount() {
    if (!SessionInfo.session || SessionInfo.session === '')
      return;
    this.handleResize = () => {
      document.documentElement.style.setProperty('--screen-height', window.innerHeight + 'px');
      this.checkMealListScroll();
    };
    window.addEventListener('resize', this.handleResize);
    requestAnimationFrame(() => this.checkMealListScroll());
    SessionInfo.currentPage = "WinePairingPage";
    this.setState({ NotifyMessage: '' });
    // Load meal items for the current store location
    try {
      trace(`WinePairing - StoreLocationID: ${SessionInfo.StoreLocationID}`);
      let CD = await CallOM('GetStoreItemsMeals',0,SessionInfo.StoreLocationID,0);
      if (CD.x.o < 9500 && CD.d && CD.d && CD.d.rows) {
        let StoreItems = CD.d.rows.map(dataItem => Object.assign({ Selected: false },dataItem));
        this.setState({ StoreItems });
      }
    } catch (error) {
      trace(`WinePairingPage Mount Error: ${error}`);
    }
    if (SessionInfo.MonitorProcessWR == false && this.monitorStart == false) {
      // Start Monitor   
      console.log(`Starting Monitor Process in WinePairingPage`);
      SessionInfo.MonitorProcessWR = true;
      this.monitorProcess();
    } else if (SessionInfo.MonitorProcessWR == true && this.monitorStart == false) {
      // Previous instance left monitor running but this instance hasn't started - restart
      console.log(`Restarting Monitor Process in WinePairingPage after remount`);
      SessionInfo.MonitorProcessWR = true;
      this.monitorProcess();
    }
    if (SessionInfo.AIWineResponse && SessionInfo.AIWineResponse.length > 10 && SessionInfo.AIWineList && SessionInfo.AIWineList.length > 0) {
      await this.setState(({ Recommendation: SessionInfo.AIWineResponse,showRecommendationPopup: true }));
      await this.setState(({ RecommendedWines: SessionInfo.AIWineList }));
      if (SessionInfo.AICurrentStoreItems)
        await this.setState(({ StoreItems: SessionInfo.AICurrentStoreItems }));
    }
    else { // No current Recommendation
      let CD = await CallOM("RetrieveCurrentOrder",0,0,0); // Returns list of StoreItem Primary Keys in the current order
      console.log(`Current Order CD: ${JSON.stringify(CD)}`);
      if (CD.x.o < 9500 && CD.d && Array.isArray(CD.d) && CD.d.length > 0) { // Display Current Order Selection of Items
        let orderIDs = new Set(CD.d.map(id => Number(id)));
        let StoreItems = this.state.StoreItems.slice();
        StoreItems.forEach(item => {
          if (orderIDs.has(Number(item.StoreItemID)))
            item.Selected = true;
        });
        this.setState({ StoreItems });
        console.log(`Current Order - matched ${StoreItems.filter(i => i.Selected).length} meal(s)`);
      } else if (SessionInfo.AICurrentStoreItems) {
        await this.setState(({ StoreItems: SessionInfo.AICurrentStoreItems }));
      }
    }
  }
  shouldComponentUpdate() {
    if (this.compUpdate === true)
      return true;
    else
      return false;
  }
  componentDidUpdate(prevProps,prevState) {
    if (prevState.StoreItems !== this.state.StoreItems) {
      this.checkMealListScroll();
    }
  }
  componentWillUnmount() {
    if (this.handleResize)
      window.removeEventListener('resize', this.handleResize);
    SessionInfo.MonitorProcessWR = false;
    if (this.timeout)
      clearTimeout(this.timeout);
    this.monitorStart = false;
    this.timerSet = false;
    SessionInfo.AICurrentStoreItems = this.state.StoreItems;
    SessionInfo.AsyncTxID = 0;
  }
  //------------------------------------------------------------------------------------------------
  setTimer() {
    if (SessionInfo.loggedOn === true && SessionInfo.MonitorProcessWR === true) {
      this.timerSet = true;
      this.timeout = setTimeout(this.monitorProcess.bind(this),1000); // in milliseconds 
    }
  }
  //----- Timer Process - Application Control Logic -------------------------------------------------
  monitorProcess = async () => {
    this.firstTime = false;
    this.timerSet = false;
    this.monitorStart = true;
    if (SessionInfo.forceLogoff === true)
      this.props.navigate("/Login");
    if (SessionInfo.SetCurrentTab) {
      SessionInfo.SetCurrentTab = false;
      await this.selectTab(SessionInfo.GoToTab);
    }
    if (SessionInfo.AsyncTxID > 0) {
      SessionInfo.AsyncCounter++;
      this.queryTimer++;
      console.log(`Call RetrieveAsyncTx - txid: ${SessionInfo.AsyncTxID}`);
      let CD = await CallOMT("RetrieveAsyncTx",CTYP.INT,SessionInfo.AsyncTxID); // Determine current status of asynchronous transaction - if complete, retrieve answer and wine list
      console.log(`RetrieveAsyncTx CD: ${JSON.stringify(CD)}, txid: ${SessionInfo.AsyncTxID}`);
      SessionInfo.SaveAsyncTxID = SessionInfo.AsyncTxID;
      console.log(`-------- Transaction: ${SessionInfo.AsyncTxID} Complete - Seconds: ${SessionInfo.AsyncCounter} - Code: ${CD.x.p} ---------------`);
      if (CD.x.p >= 10) { // Completed  
        try {
          if (CD.x.p === 15) { // Error
            ReactDOM.flushSync(() => {
              this.setState({ AnswerDetail: `Error fetching Wine Recommendation` });
            });
            SessionInfo.AsyncTxID = 0;
            SessionInfo.AsyncCounter = 0;
          } else if (CD.x.p === 10) { //---- Success - Retrieve Answer ----
            let CD = await CallOMT("RetrieveWRAnswer",CTYP.INT,SessionInfo.AsyncTxID);
            console.log(`WR Answer Returned - TxID: ${SessionInfo.AsyncTxID}, Async Cnt: ${SessionInfo.AsyncCounter}, length: ${CD.d.length}`);
            ReactDOM.flushSync(() => {
              this.setState({ Recommendation: CD.d });
            });
            try {
              SessionInfo.AIWineResponse = CD.d; // Store in SessionInfo for retrieval if user navigates away and back to page
              console.log(`AIResponse set in SessionInfo - length: ${SessionInfo.AIWineResponse.length}`);
            }
            catch (error) {
              console.log(`Error in setting AIResponse: ${error}`);
            }
            console.log(`---> Retrieving Wine List for TxID: ${SessionInfo.AsyncTxID}`);
            CD = await CallOMT("RetrieveWineList",CTYP.INT,SessionInfo.AsyncTxID);
            console.log(`WineList Returned - TxID: ${SessionInfo.AsyncTxID}, List: ${JSON.stringify(CD.d)}`);
            let RecommendedWines;
            if (CD.d) {
              RecommendedWines = CD.d.map((w,i) => typeof w === 'string' ? { WineID: i + 1,WineName: w,StoreItemID: 0,Selected: false } : { WineID: i + 1,Selected: false,...w });
            }
            else
              RecommendedWines = [{ WineID: 1,WineName: 'No Wines Recommended',StoreItemID: 0,Selected: false }];
            ReactDOM.flushSync(() => {
              this.setState({ RecommendedWines,showGIF: false });
            });
            SessionInfo.AIWineList = this.state.RecommendedWines;
            console.log(`Wine List Saved - Length: ${SessionInfo.AIWineList.length}`);
            SessionInfo.AICurrentStoreItems = this.state.StoreItems; // Store current meal selection in SessionInfo for retrieval if user navigates away and back to page
            console.log(`AIWineList set in SessionInfo - length: ${SessionInfo.AIWineList.length}`);
            SessionInfo.AsyncTxID = 0;
            SessionInfo.AsyncCounter = 0;
            SessionInfo.CurrentlyInRecommendation = false;
          }
        } catch (error) {
          console.log(`Error in monitorProcess asyncTx retrieval: ${error}`);
        }
      }
      else {
        console.log(`Transaction ${SessionInfo.AsyncTxID} not complete -Time: ${this.queryTimer}`);
        ReactDOM.flushSync(() => {
          this.setState({ Recommendation: this.recommendTime + ` Seconds Counter: ${this.queryTimer}` });
        });
      }
    }
    this.setTimer();
  }
  // 
  gotoLanding = async () => {
    trace("Go To LandingPage");
    this.props.navigate("/LandingPage");
  }
  openMenu = (event) => {
    event.stopPropagation();
    this.setState({ showMenu: true });
  }
  onMenuItemClick = async (event) => {
    trace(`menu event Item: ${event.item.text}`);
    if (SessionInfo.currentItem !== undefined) {
      SessionInfo.currentItem.Selected = false;
    }
    SessionInfo.currentItem = event.item;
    event.item.Selected = true;
    event.item.expanded = true;
    SessionInfo.MenuSelect = event.item;
    this.setState({ showMenu: false });
    if (SessionInfo.menuAction !== undefined) {
      await SessionInfo.menuAction();
    }
    this.forceUpdate();
  }
  closePopups = () => {
    this.setState({ showMenu: false });
  }
  notifyTimeout = null;
  notify = (msg,isError = false,keep = false) => {
    if (this.notifyTimeout)
      clearTimeout(this.notifyTimeout);
    this.setState({ NotifyMessage: msg,NotifyIsError: isError });
    if (keep === false) {
      this.notifyTimeout = setTimeout(() => {
        this.setState({ NotifyMessage: '' });
        this.notifyTimeout = null;
      },6000);
    }
  }
  // Toggling a meal also clears any previously cached AI response, same as the prior
  // Grid-based onRowClick + checkbox handlers combined.
  toggleMealSelection = (storeItemID) => {
    let current = this.state.StoreItems.findIndex(p => p.StoreItemID === storeItemID);
    if (current < 0) return;
    let StoreItems = this.state.StoreItems.slice();
    StoreItems[current] = { ...StoreItems[current],Selected: !StoreItems[current].Selected };
    this.setState({ StoreItems });
    SessionInfo.AIWineResponse = ''; // Clear any previous AI response when meal selection changes
  }
  checkMealListScroll = () => {
    let el = this.mealListRef.current;
    if (!el) {
      if (this.state.showMealScrollHint !== false)
        this.setState({ showMealScrollHint: false });
      return;
    }
    let canScroll = el.scrollHeight - el.clientHeight > 4;
    let atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 4;
    let showMealScrollHint = canScroll && !atBottom;
    if (showMealScrollHint !== this.state.showMealScrollHint)
      this.setState({ showMealScrollHint });
  }
  renderMealItem = (item) => {
    let isSelected = item.Selected === true;
    return (
      <div key={item.StoreItemID} className={`wp-meal-item${isSelected ? ' wp-selected' : ''}`}>
        <input type="checkbox" className="wp-meal-checkbox" checked={isSelected} onChange={() => this.toggleMealSelection(item.StoreItemID)} />
        <span className="wp-meal-name" onClick={() => this.toggleMealSelection(item.StoreItemID)}>{item.ItemName}</span>
      </div>
    );
  }
  toggleWineSelection = async (wineID) => {
    let RecommendedWines = this.state.RecommendedWines.slice();
    let idx = RecommendedWines.findIndex(w => w.WineID === wineID);
    if (idx < 0) return;
    let wine = { ...RecommendedWines[idx] };
    let nowSelected = !wine.Selected;
    wine.Selected = nowSelected;
    RecommendedWines[idx] = wine;
    SessionInfo.AIWineList = RecommendedWines;
    this.setState({ RecommendedWines });
    this.notify(nowSelected ? `Selected: ${wine.WineName}` : `Deselected: ${wine.WineName}`);
    let CD = await CallOMT('AddWineToOrder',TYP.INT,SessionInfo.CustomOrderID,TYP.BL,nowSelected,TYP.STR,wine.WineName);
    console.log(`AddWineToOrder CD: ${JSON.stringify(CD)}, nowSelected: ${nowSelected}`);
  }
  renderWineItem = (item) => {
    let wineName = typeof item === 'string' ? item : item.WineName;
    let isSelected = typeof item === 'object' && item.Selected === true;
    let wineID = typeof item === 'object' ? item.WineID : null;
    return (
      <div key={wineID ?? wineName} className={`wp-wine-item${isSelected ? ' wp-selected' : ''}`}>
        {wineID !== null &&
          <input type="checkbox" className="wp-wine-checkbox" checked={isSelected} onChange={() => this.toggleWineSelection(wineID)} />}
        <span style={{ flex: 1,minWidth: 0,overflowWrap: 'break-word' }} onClick={() => wineID !== null && this.toggleWineSelection(wineID)}>{wineName}</span>
      </div>
    );
  }
  chgTAFldVal = (event) => {
    this.setState({ [event.target.name]: event.value });
  }
  recommendWine = async () => {
    if (SessionInfo.AIWineResponse.length > 10) {
      this.setState({ isLoading: false,Recommendation: SessionInfo.AIWineResponse,RecommendedWines: SessionInfo.AIWineList });
      this.setState({ showRecommendationPopup: true });
      this.notify('Displaying Current Recommendations',false);
    } else {
      let selectedMeals = this.state.StoreItems.filter(item => item.Selected === true);
      if (selectedMeals.length === 0) {
        this.notify('Please select at least one meal for your dinner.',true);
        return;
      }
      let mealNames = selectedMeals.map(item => item.ItemName).join(', ');
      let comments = this.state.WinePreferenceComments || '';
      trace(`Recommend Wine - Meals: ${mealNames}, Comments: ${comments}`);
      this.setState({ isLoading: true,Recommendation: '',RecommendedWines: [] });
      try {
        let mealIDs = selectedMeals.map(item => item.StoreItemID);
        this.setState({ Recommendation: this.recommendTime });
        this.setState({ showRecommendationPopup: true });
        this.queryTimer = 0;
        this.notify('Getting Wine Recommendations base on your preferences',false);
        let CD = await CallOM('GetWineRecommendation',0,SessionInfo.StoreLocationID,CTYP.TypParm,[TYP.IAR,mealIDs,TYP.STR,comments]);
        if (CD.d !== undefined) {
          SessionInfo.CurrentlyInRecommendation = true;
          this.setState({ NotifyMessage: '' });
          SessionInfo.AsyncTxID = Number(CD.d); // Transaction ID returned from server to retrieve answer in monitorProcess
          SessionInfo.AsyncCounter = 0;
          if (SessionInfo.AsyncTxID > 0) {
            this.setState({ showGIF: true });
          }
          try {
            this.setState({ AnswerDetail: `Transaction ID: ${CD.d}` });
          } catch (error) {
            console.log(`Error in AskQuestion: ${error}`);
            this.setState({ AnswerDetail: "" });
          }
        }
        else {
          this.setState({ AnswerDetail: "Wine Recommentation Request Failed" });
          SessionInfo.CurrentlyInRecommendation = false;
        }
      } catch (error) {
        trace(`Recommend Wine Error: ${error}`);
        this.notify('Error getting wine recommendation.',true);
        SessionInfo.CurrentlyInRecommendation = false;
      }
      this.setState({ isLoading: false });
    }
  }
  closeRecommendationPopup = () => {
    SessionInfo.AsyncTxID = 0; // Clear any pending transaction
    this.setState({ showRecommendationPopup: false });
  }
  clearSelection = async () => {
    let StoreItems = this.state.StoreItems.slice();
    StoreItems.forEach(item => { item.Selected = false; item.Choice = false; });
    await new Promise(resolve => {
      this.setState({ StoreItems,WinePreferenceComments: '',Recommendation: '',RecommendedWines: [],showRecommendationPopup: false },resolve);
    });
    SessionInfo.AIWineList = []; // Clear stored wine list
    SessionInfo.AIWineResponse = ''; // Clear stored AI response
    SessionInfo.AICurrentStoreItems = undefined; // Clear stored meal selection
  }
  //----------------------------------------------------------------------------------------------------------------------------------
  render() {
    return (
      <div id="WinePairingPage" className="pageMain wp-page">

        <div id="hdr" className="wp-header" onClick={(e) => this.closePopups(e)}>
          {SessionInfo.HasLandingPage ?
            <a className="wp-logo-btn" ref={this.logoAnchor} style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})` }} onClick={(e) => this.gotoLanding()} /> :
            <a className="wp-logo-btn" ref={this.logoAnchor} style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})` }} href={SessionInfo.RestaurantURL} target="_blank" rel="noopener noreferrer" />}
          <div className="wp-header-text">
            <span className="wp-title">Wine Recommendations</span>
            {this.state.NotifyMessage !== '' &&
              <div className={`wp-notify ${this.state.NotifyIsError ? 'wp-notify-error' : 'wp-notify-ok'}`}>
                {this.state.NotifyMessage}
              </div>}
          </div>
          <MenuBar alt="" fill={SessionInfo.headingTextColor} id="MenuBtn" title={`View Menu`} className="wp-menu-btn" onClick={(e) => this.openMenu(e)} ref={this.menuAnchor} />
        </div>

        <div className="wp-header-actions">
          <Button icon="search" look="outline" className="wp-btn wp-btn-header" onClick={this.recommendWine} disabled={this.state.isLoading}>
            {this.state.isLoading ? 'Recommending...' : 'Recommend Wine'}
          </Button>
          <Button icon="reset" look="outline" className="wp-btn wp-btn-header" onClick={this.clearSelection}>Clear</Button>
        </div>

        <Popup anchor={this.menuAnchor.current} show={this.state.showMenu} popupClass={'wp-menu-popup'} >
          <div className="wp-menu-drawer">
            <a className="wp-menu-drawer-logo" style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})` }} href="http://www.omnovos.com" target="_blank" rel="noopener noreferrer" />
            <div className="wp-menu-tree">
              {SessionInfo.AppCfg.HasScanAndPay === false ?
                <br /> : null}
              {SessionInfo.defaultLogon === true ?
                <br /> : null}
              <TreeView
                data={SessionInfo.MenuControlNQR}
                size='large' draggable='false' selection='single'
                onItemClick={this.onMenuItemClick}
                item={props => [<span key={props.item.key} className={props.item.className}>{props.item.icon}{props.item.space}{props.item.text}</span>]}
              />
            </div>
          </div>
        </Popup>

        <div className="wp-body">
          {/* ===== Section 1: Select Dinner Meals ===== */}
          <div className="wp-section" ref={(div) => { this.recommendPos = div; }}>
            <label className="wp-section-title">Identify Your Menu Choices</label>
            <div className="wp-meal-list" ref={this.mealListRef} onScroll={this.checkMealListScroll}>
              {this.state.StoreItems.length === 0 ?
                <div className="wp-empty-row">No meal items found for this location.</div> :
                this.state.StoreItems.map(item => this.renderMealItem(item))}
            </div>
            {this.state.showMealScrollHint &&
              <div className="wp-scroll-hint" aria-hidden="true">
                <span className="wp-scroll-hint-chevron">⌄</span>Scroll for more
              </div>}
          </div>

          {/* ===== Section 2: Wine Preference Comments ===== */}
          <div className="wp-section">
            <label className="wp-section-hint">Any additional wine info - references, restrictions, or notes? (Note that the wine recommendations only include wines currently in our cellar)</label>
            <TextArea name="WinePreferenceComments" rows={4} className="wp-textarea" value={this.state.WinePreferenceComments} onChange={(e) => this.chgTAFldVal(e)} />
          </div>

          {/* ===== Section 3: Recommend Button ===== */}
          <div className="wp-btn-row">
            <Button icon="search" look="outline" className="wp-btn wp-btn-primary" onClick={this.recommendWine} disabled={this.state.isLoading}>
              {this.state.isLoading ? 'Recommending...' : 'Recommend Wine'}
            </Button>
            <Button icon="reset" look="outline" className="wp-btn wp-btn-secondary" onClick={this.clearSelection}>Clear</Button>
          </div>
        </div>

        {/* ===== Wine Recommendation Modal ===== */}
        <Popup anchor={this.logoAnchor.current} show={this.state.showRecommendationPopup} popupClass={'wp-modal-overlay'} >
          <div className="wp-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="wp-modal-header">
              <span className="wp-modal-title">Wine Recommendation</span>
              <Button icon="close" look="flat" title="Close" onClick={this.closeRecommendationPopup} />
            </div>
            <div className="wp-modal-body">
              {this.state.RecommendedWines.length > 0 &&
                <div>
                  <label className="wp-section-title" style={{ fontSize: 'clamp(0.8rem, 3.4vw, 0.95rem)' }}>Recommended Wines</label>
                  <div className="wp-wine-list">
                    {this.state.RecommendedWines.map(item => this.renderWineItem(item))}
                  </div>
                </div>
              }
              <div className="wp-recommendation-wrap">
                <label className="wp-section-title" style={{ fontSize: 'clamp(0.8rem, 3.4vw, 0.95rem)' }}>Recommendation Details</label>
                <div className="wp-recommendation-box">
                  {this.state.Recommendation}
                </div>
              </div>
              {this.state.showGIF && (
                <div className="wp-loading-wrap">
                  <img src={loadingGif} alt="Processing..." className="wp-loading-img" />
                </div>
              )}
            </div>
            {/* Popup Footer */}
            <div className="wp-modal-footer">
              <Button icon="close" look="outline" className="wp-btn wp-btn-secondary" onClick={this.closeRecommendationPopup}>Close</Button>
            </div>
          </div>
        </Popup>

      </div>
    );
  }
}

export default withRouter(WinePairingPage);
